import IncrementStepper from '@/components/reusable/incrementStepper/IncrementStepper';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import { Control, Controller } from 'react-hook-form';
import styles from './IncrementStepperSection.module.scss';
import { FC } from 'react';
import { MoreFiltersData } from '../../MidTermMoreFilters';
interface PropsType {
  title: string;
  control: Control<MoreFiltersData>;
  name: string;
  min?: number;
}
const IncrementStepperSection: FC<PropsType> = ({
  title,
  control,
  name,
  min
}) => {
  return <Box className={styles['increment-stepper-section-container']} data-sentry-element="Box" data-sentry-component="IncrementStepperSection" data-sentry-source-file="IncrementStepperSection.tsx">
      <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="IncrementStepperSection.tsx">{title}</Typography>
      <Controller name={name} control={control} render={({
      field: {
        value,
        onChange,
        ...props
      }
    }) => <IncrementStepper format="outline" handleChange={type => {
      if (type === 'increase') {
        onChange(Number(value) + 1);
      } else {
        onChange(Number(value) - 1);
      }
    }} label="نفر" value={Number(value)} minimumValue={Number(min) ? min : 0} />} data-sentry-element="Controller" data-sentry-source-file="IncrementStepperSection.tsx" />
    </Box>;
};
export default IncrementStepperSection;